/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Extra service in a booking
 * @export
 * @interface TravelineBookingServiceRqDto
 */
export interface TravelineBookingServiceRqDto {
    /**
     * Service ID
     * @type {string}
     * @memberof TravelineBookingServiceRqDto
     */
    id: string;
}

/**
 * Check if a given object implements the TravelineBookingServiceRqDto interface.
 */
export function instanceOfTravelineBookingServiceRqDto(value: object): value is TravelineBookingServiceRqDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function TravelineBookingServiceRqDtoFromJSON(json: any): TravelineBookingServiceRqDto {
    return TravelineBookingServiceRqDtoFromJSONTyped(json, false);
}

export function TravelineBookingServiceRqDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineBookingServiceRqDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

  export function TravelineBookingServiceRqDtoToJSON(json: any): TravelineBookingServiceRqDto {
      return TravelineBookingServiceRqDtoToJSONTyped(json, false);
  }

  export function TravelineBookingServiceRqDtoToJSONTyped(value?: TravelineBookingServiceRqDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
    };
}

